import { formatTime } from '@retro-ui/shared';
import _ from 'lodash';

import cls from './SynthesisTreeInfo.module.css';

export function SynthesisTreeInfo({ data, className }) {
  return (
    <div className={className}>
      <div className={cls.item}>
        <p className={cls.itemName}>Target SMILES</p>
        {data.searchResultInfo.targetSmiles}
      </div>
      <div className={cls.columns}>
        <div className={cls.item}>
          <p className={cls.itemName}>Name</p>
          {data.searchResultInfo.name ?? 'Unnamed'}
        </div>
        <div className={cls.item}>
          <p className={cls.itemName}>Score</p>
          {data.searchResultInfo.score < 1 || _.isNaN(data.searchResultInfo.score)
            ? 'n/a'
            : data.searchResultInfo.score}
        </div>
        <div className={cls.item}>
          <p className={cls.itemName}>SM Price</p>
          {Number(data.searchResultInfo.price) > 0 ? `~ $${Number(data.searchResultInfo.price).toFixed(2)}` : 'n/a'}
        </div>
        <div className={cls.item}>
          <p className={cls.itemName}>Reactions</p>
          {data.searchResultInfo.reactionCount ?? 'n/a'}
        </div>
        {data.searchResultInfo.referenceCount && (
          <div className={cls.item}>
            <p className={cls.itemName}>References</p>
            {data.searchResultInfo.referenceCount}
          </div>
        )}
        <div className={cls.item}>
          <p className={cls.itemName}>Running time</p>
          {data.searchResultInfo.runningTime ? formatTime(data.searchResultInfo.runningTime) : 'n/a'} (h:m:s)
        </div>
        {data.searchParams && (
          <div className={cls.item}>
            <p className={cls.itemName}>Parameters</p>
            <ul>
              <li>Model: {data.searchParams.presets.model}</li>
              <li>Synthesis scale: {data.searchParams.presets.synthesis_scale}</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
